import { DrawerVariantPositionTypes, } from '@kubit/web-ui-components/drawer/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { desktopCommonStyles, mobileCommonStyles, tabletCommonStyles } from '../commonStyles';
import { DrawerVariant } from '../variants';
export const getColoredStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    [DrawerVariant.COLORED]: {
        [DeviceBreakpointsType.DESKTOP]: {
            ...desktopCommonStyles(FOUNDATIONS, SHADOWS),
            container: {
                ...desktopCommonStyles(FOUNDATIONS, SHADOWS).container,
                [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                    ...desktopCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_RIGHT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                    ...desktopCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_LEFT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                    ...desktopCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_BOTTOM],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
            },
            footer: {
                ...desktopCommonStyles(FOUNDATIONS, SHADOWS).footer,
                background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
            },
        },
        [DeviceBreakpointsType.TABLET]: {
            ...tabletCommonStyles(FOUNDATIONS, SHADOWS),
            container: {
                ...tabletCommonStyles(FOUNDATIONS, SHADOWS).container,
                [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                    ...tabletCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_RIGHT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                    ...tabletCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_LEFT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                    ...tabletCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_BOTTOM],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
            },
        },
        [DeviceBreakpointsType.MOBILE]: {
            ...mobileCommonStyles(FOUNDATIONS, SHADOWS),
            container: {
                ...mobileCommonStyles(FOUNDATIONS, SHADOWS).container,
                [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                    ...mobileCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_RIGHT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                    ...mobileCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_LEFT],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
                [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                    ...mobileCommonStyles(FOUNDATIONS, SHADOWS).container?.[DrawerVariantPositionTypes.DRAWER_BOTTOM],
                    background_color: FOUNDATIONS.color_comp_containers_highlighted_bg,
                },
            },
        },
    },
});
//# sourceMappingURL=colored.js.map